/**
 * @generated SignedSource<<ed34adfb7ca3e0646eb351334ae79a67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuRef_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly refId: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuRef_Product";
};
export type ProductSkuRef_Product$key = {
  readonly " $data"?: ProductSkuRef_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuRef_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuRef_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "f9b7fa9c78d254c09a02dc96a860c961";

export default node;
